import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-left text-xl font-bold text-textPrimary" }, "Registros não aprovados no lote", -1)
const _hoisted_2 = { class: "flex flex-col gap-2 text-left" }
const _hoisted_3 = ["data-testid"]
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = { class: "text-sm font-semibold text-textPrimary" }
const _hoisted_6 = {
  key: 0,
  class: "font-normal text-gray-500"
}
const _hoisted_7 = ["data-testid", "onClick"]
const _hoisted_8 = { class: "flex justify-end" }

import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import type { BulkApproveOutcomeRow } from '../utils/bulk-approve'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceBulkApproveResultModal',
  props: {
    modelValue: { type: Boolean },
    rows: {},
    subtitles: {}
  },
  emits: ["update:modelValue", "open"],
  setup(__props: any, { emit }) {

/**
 * Spec 2026-09-24 §8.2 — o toast do lote diz QUANTOS não entraram; este modal diz QUAIS e
 * POR QUÊ, com atalho para abrir o registro (ex.: confirmar a sobrescrita um a um).
 */




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[640px]",
    onClose: _cache[1] || (_cache[1] = ($event: any) => (emit('update:modelValue', false)))
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(OutlineButton, {
          text: "Fechar",
          width: "96px",
          height: "40px",
          "data-testid": "bulk-approve-result-close-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('update:modelValue', false)))
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
          return (_openBlock(), _createElementBlock("li", {
            key: row.containerId,
            class: "flex flex-col gap-1 rounded border border-gray-30 px-3 py-2 sm:flex-row sm:items-center sm:justify-between",
            "data-testid": `bulk-approve-result-row-${row.containerId}`
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _createTextVNode(" Registro #" + _toDisplayString(row.containerId) + " ", 1),
                (_ctx.subtitles?.[row.containerId])
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, " · " + _toDisplayString(_ctx.subtitles[row.containerId]), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("span", {
                class: _normalizeClass(["text-sm", row.kind === 'failed' ? 'text-negative' : 'text-alert'])
              }, _toDisplayString(row.label), 3)
            ]),
            (row.canOpen)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "shrink-0 text-sm font-semibold text-primary30 underline",
                  "data-testid": `bulk-approve-result-open-${row.containerId}-button`,
                  onClick: ($event: any) => (emit('open', row.containerId))
                }, " Abrir registro ", 8, _hoisted_7))
              : _createCommentVNode("", true)
          ], 8, _hoisted_3))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})